


import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { ShakenShohiyou } from "@/model/shakenShohiyou";
import { Getter, Action } from "vuex-class";
import Number from "@/shared/filters/Number.ts";
import { MESSAGE } from "@/model/Message";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import * as util from "@/service/util";
import { UserService } from "@/service/UserService";
import { ElForm } from "element-ui/types/form";
import { ElButton } from "element-ui/types/button";
import InputNumber from "@/components/common/input/InputNumber.vue";
import JibaiseikiDialog from "@/components/JibaiseikiDialog.vue";
import JuuryouzeiDialog from "@/components/JuuryouzeiDialog.vue";
import { JuuryouzeiJibaiseikiSave } from "@/model/JuuryouzeiJibaiseikiSave";
import UserFooter from "@/components/UserFooter.vue";
import { RyoukinRank, Hikazei3, HikazeiRyoukin } from "@/model/RyoukinRank";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { Item } from "@/model/shakenShohiyou";
import { StompClient } from "@/service/StompClient";
import InspectionCostPage from "@/page/user/InspectionCostPage.vue";

export interface SideTab {
  status: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    InputNumber,
    JibaiseikiDialog,
    JuuryouzeiDialog,
    UserFooter,
    TopBarTitle
  }
})
export default class InspectionCostPageQuick extends InspectionCostPage {
  isMode_modal:boolean = false;
  isMode_quick:boolean = true;

onSubmitTax() {
    this.$refs.taxForm.validate((valid: boolean) => {
      if (valid) {
        this.formData.zeiJibaisekiZn = this.formData.zeiJibaisekiZk;
        if (this.isMadoguchiInshidaiChecked) {
          this.formData.zeiInshidaiZn = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiZk = this.inshidaiMadoguchi;
          this.formData.zeiInshidaiGenka = this.inshidaiMadoguchi;
        }
        this.formData.isMadoguchiInshidai = this.isMadoguchiInshidaiChecked ? 1 : 0;
        const data: JuuryouzeiJibaiseikiSave = {
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          ...this.formData
        };
        this.updateTax(this.formData);
        this.displayDialogTax = false;
        /** 2021-10-01 sh #7438 implements tech info amount. [START] */
        /** 送る必要がないので、除外する */
        delete data.zeiTechInfoAmountZk;
        delete data.zeiTechInfoAmountZn;
        delete data.isUseTechInfoAmount;
        /** 2021-10-01 sh #7438 implements tech info amount. [END] */
        this.reqService.saveTax(data).then((res: any) => {
          const userService = new UserService();
          userService.getShohiyouQM();
        });
      }
    });
  }

  resetKensaHiyou() {
    this.reqService.resetKensaHiyouQM(this.uketsukeExtendsId).then(
      (response: any) => {
        const userService = new UserService();
        userService.getShohiyouQM();
      },
      (err: any) => {
        this.$notify.error({
          title: "エラー",
          message: MESSAGE.SystemError
        });
      }
    );
  }

}
